import request from '@/utils/request'

export function getList(params) {
  return request({
    url: '/iMEIs/load',
    method: 'get',
    params
  })
}

export function add(data) {
  return request({
    url: '/iMEIs/add',
    method: 'post',
    data
  })
}

export function update(data) {
  return request({
    url: '/iMEIs/update',
    method: 'post',
    data
  })
}

export function del(data) {
  return request({
    url: '/iMEIs/delete',
    method: 'post',
    data
  })
}

